import React from 'react';

const space = '\u00A0';

export default function NonBreakingSpace(props) {
  return <span>{space}</span>;
}
